import Pagination from "@amzn/meridian/pagination";
import Row from "@amzn/meridian/row";
import Select, { SelectOption } from "@amzn/meridian/select";
import Text from "@amzn/meridian/text";
import { PAGINATION_OPTIONS } from "src/constants/constants";
import "./paginationWithDropdown.scss";

interface PaginationWithDropdownProps {
  totalResults: number;
  totalPages: number;
  currentPage: number;
  perPage: number;
  setPerPage: (newPerPage: number) => void;
  setCurrentPage: (newPage: number) => void;
}
const PaginationWithDropdown = ({
  totalResults,
  totalPages,
  currentPage,
  perPage,
  setPerPage,
  setCurrentPage,
}: PaginationWithDropdownProps) => {
  return (
    <Row
      className="pagination"
      spacingInset={"500 none none none"}
      alignmentHorizontal="center"
    >
      <Text>{totalResults} results</Text>
      <Pagination
        numberOfPages={totalPages}
        onChange={(newPage) => setCurrentPage(newPage)}
        currentPage={currentPage}
        showSkipArrows={true}
      />
      <div className="pagination__page-size">
        <Select
          value={perPage}
          onChange={(perPage) => {
            setPerPage(perPage);
          }}
          label="Page Size"
        >
          {PAGINATION_OPTIONS.map((option) => (
            <SelectOption
              key={option}
              label={option}
              value={option}
            ></SelectOption>
          ))}
        </Select>
      </div>
    </Row>
  );
};

export default PaginationWithDropdown;
